import React from 'react';

const FilterTypeSelector = ({ 
  selectedFilterType, 
  onFilterTypeChange, 
  disabled = false 
}) => {
  // Filter type configurations
  const filterTypes = [
    { type: 'airport', label: 'Airport' },
    { type: 'operator', label: 'Operator' },
    { type: 'aircraftType', label: 'Aircraft Type' },
    { type: 'registration', label: 'Registration' },
    { type: 'category', label: 'Category' }
  ];

  const handleFilterTypeChange = (e) => {
    if (!disabled && onFilterTypeChange) {
      onFilterTypeChange(e.target.value);
    }
  };

  return (
    <div className="filter-type-selector">
      <label className="filter-type-label" htmlFor="filter-type-select">
        Filter by:
      </label>
      <select
        id="filter-type-select"
        className="filter-type-select"
        value={selectedFilterType}
        onChange={handleFilterTypeChange}
        disabled={disabled}
      >
        {filterTypes.map((filterType) => (
          <option key={filterType.type} value={filterType.type}>
            {filterType.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FilterTypeSelector;